import React, { useEffect, useState } from "react";
import {
  StakeBalanceCard,
  StakeButton,
  StakeCard,
  StakeContainer,
  StakeInput,
  StakeWrapper,
} from "./Stake.styled";
import { useLocation, useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import { FormError } from "../Auth.styled";
import { useDispatch, useSelector } from "react-redux";
import { getUserBalance } from "../../feature/wallet/WalletActions";
import { clearInputError } from "../../feature/inputError/inputErrorSlice";
import { createStake } from "../../feature/stake/StakeActions";
import SuccessPage from "../SuccessPage/SuccessPage";
import ReactLoading from "react-loading";

const Stake = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const selectedStakePlan =
    location.state !== null && location.state.selectedStakePlan;
  const [staked, setStaked] = useState(false);

  const MINIMUM_AMOUNT = selectedStakePlan && selectedStakePlan.minimum_amount;

  const { inputError } = useSelector((state) => state.inputError);
  const { createStakeIsLoading } = useSelector((state) => state.stake);
  const { balance } = useSelector((state) => state.wallet);
  const { user } = useSelector((state) => state.user);

  useEffect(() => {
    Object.keys(user).length && dispatch(getUserBalance({ user: user }));
    dispatch(clearInputError());
  }, [dispatch, user]);

  useEffect(() => {
    location.state === null && navigate("/staking");
  }, [location.state, navigate]);

  const initialValues = {
    amount: "",
  };

  const onSubmit = (values) => {
    dispatch(
      createStake({
        user: user.id,
        stake_plan: selectedStakePlan.id,
        amount: values.amount,
      })
    )
      .unwrap()
      .then((res) => setStaked(true))
      .catch((error) => console.log(error));
  };

  const validationSchema = Yup.object({
    amount: Yup.number()
      .min(MINIMUM_AMOUNT, `amount must be greater than ${MINIMUM_AMOUNT}`)
      .max(balance, `amount must be less or equal to ${balance}`)
      .required("amount is required"),
  });

  const formik = useFormik({
    initialValues,
    onSubmit,
    validationSchema,
  });

  return (
    <>
      {staked ? (
        <SuccessPage
          message="TRX Staked Successfully"
          links={[
            { link: "/staking", name: "staking" },
            { link: "/stakes", name: "stakes" },
          ]}
        />
      ) : (
        <StakeContainer>
          <StakeCard>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
              }}
            >
              <div>
                <div style={{ marginBottom: "5px" }}>
                  {selectedStakePlan && selectedStakePlan.staking_duration} Days
                  Staking
                </div>
              </div>
              <div>
                <div>Minimum Amount:</div>
                <div style={{ color: "#C597F8", marginBottom: "5px" }}>
                  {MINIMUM_AMOUNT} TRX
                </div>
              </div>
              <div>
                <div>% of return:</div>
                <div style={{ color: "#C597F8", marginBottom: "5px" }}>
                  {selectedStakePlan && selectedStakePlan.percentage}%
                </div>
              </div>
              <div>
                <div>Return on stake:</div>
                <div style={{ color: "#C597F8", marginBottom: "5px" }}>
                  {(formik.values.amount *
                    parseInt(selectedStakePlan.percentage)) /
                    100}{" "}
                  TRX
                </div>
              </div>
            </div>
          </StakeCard>
          <div>Amount to stake:</div>
          <form onSubmit={formik.handleSubmit}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                marginBlock: "20px 0",
              }}
            >
              <StakeWrapper>
                <StakeInput
                  type="number"
                  pattern="\d*"
                  placeholder="amount"
                  name="amount"
                  onChange={formik.handleChange}
                  value={formik.values.amount}
                />
                <button
                  type="button"
                  style={{
                    width: "30%",
                    height: "30px",
                    marginInlineStart: "-70px",
                    cursor: "pointer",
                    padding: "10px",
                  }}
                  onClick={() => {
                    formik.setFieldValue("amount", balance);
                  }}
                >
                  MAX
                </button>
              </StakeWrapper>

              <StakeButton
                type="submit"
                disabled={createStakeIsLoading || balance < MINIMUM_AMOUNT}
              >
                {createStakeIsLoading ? (
                  <ReactLoading
                    type={"spinningBubbles"}
                    height={"20px"}
                    width={"20px"}
                  />
                ) : (
                  "Stake"
                )}
              </StakeButton>
            </div>
            {formik.errors.amount ? (
              <div style={{ color: "tomato", margin: 0 }}>
                {formik.errors.amount}
              </div>
            ) : null}
          </form>
          <StakeBalanceCard>
            Available Balance: <span>{balance} TRX</span>
          </StakeBalanceCard>
          {balance < MINIMUM_AMOUNT && (
            <div
              style={{
                color: "#F0BCBC",
                display: "flex",
                justifyContent: "center",
              }}
            >
              You don't have enough TRX to stake
            </div>
          )}
          <FormError>
            {inputError !== undefined
              ? inputError[0]
                ? inputError[0]
                : null
              : null}
          </FormError>
        </StakeContainer>
      )}
    </>
  );
};

export default Stake;
